import React, { useContext, useState } from "react";
import { CartContext } from "../context/CartContext";
import { API_BASE } from "../utils/env";
// import CartFormModal from "./CartFormModal"; // ⟵ removed

function CartDrawer({ onClose }) {
  const {
    cartItems,
    incrementQuantity,
    decrementQuantity,
    removeFromCart,
    clearCart,
  } = useContext(CartContext);

  const [submitting, setSubmitting] = useState(false);

  const totalPrice = cartItems.reduce(
    (acc, item) => acc + Number(item.price || 0) * Number(item.quantity || 0),
    0
  );

  const handleStripeCheckout = async () => {
    try {
      setSubmitting(true);

      // Build Stripe line_items from cart
      const items = cartItems
        .map((it) => {
          const size = it.size || it.selectedSize;
          // Prefer a priceId carried on the cart item; otherwise use product map
          const priceId =
            it.priceId ||
            it.product?.priceIdBySize?.[size] ||
            it.product?.priceId ||
            null;

          if (!priceId) {
            console.warn("Missing priceId for cart item", it);
            return null;
          }

          return { priceId, qty: Math.max(1, Number(it.quantity || 1)) };
        })
        .filter(Boolean);

      if (!items.length) {
        alert("Your cart is empty or missing price IDs.");
        return;
      }

      const res = await fetch(`${API_BASE}/api/checkout/session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || "checkout_failed");

      // Redirect to Stripe-hosted checkout
      if (data.url) {
        window.location = data.url;
        return;
      }

      // (Alternative sessionId flow with @stripe/stripe-js could go here)
      alert("Could not start checkout. Missing redirect URL.");
    } catch (e) {
      console.error(e);
      alert("Could not start checkout. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: 320,
          height: "100vh",
          background: "#fff",
          boxShadow: "-2px 0 8px rgba(0,0,0,0.15)",
          padding: 16,
          zIndex: 1000,
          overflowY: "auto",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3>Your Cart</h3>
          <button
            onClick={onClose}
            style={{
              fontSize: 20,
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
            aria-label="Close cart"
          >
            ✖
          </button>
        </div>

        {cartItems.length === 0 ? (
          <p style={{ marginTop: 40 }}>No items in cart.</p>
        ) : (
          <>
            <ul style={{ padding: 0, listStyle: "none", marginTop: 20 }}>
              {cartItems.map((item, index) => (
                <li
                  key={`${item.id}-${item.size}-${index}`}
                  style={{
                    marginBottom: 20,
                    borderBottom: "1px solid #eee",
                    paddingBottom: 8,
                  }}
                >
                  <div>
                    <strong>{item.name}</strong> ({item.size})
                  </div>

                  <div style={{ fontSize: 13, color: "#555" }}>
                    {item.spiceLevel != null ? (
                      <>
                        Spice Level: 🌶️ {item.spiceLevel}
                        <br />
                      </>
                    ) : null}
                    {item.description}
                  </div>

                  <div
                    style={{
                      marginTop: 8,
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <button
                      onClick={() => decrementQuantity(item.id, item.size)}
                      style={{
                        width: 24,
                        height: 24,
                        fontSize: 16,
                        borderRadius: 4,
                      }}
                      aria-label="Decrease quantity"
                    >
                      –
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      onClick={() => incrementQuantity(item.id, item.size)}
                      style={{
                        width: 24,
                        height: 24,
                        fontSize: 16,
                        borderRadius: 4,
                      }}
                      aria-label="Increase quantity"
                    >
                      +
                    </button>
                  </div>

                  <div style={{ marginTop: 4, fontSize: 14, color: "#000" }}>
                    Price: $
                    {(
                      Number(item.price || 0) * Number(item.quantity || 0)
                    ).toFixed(2)}{" "}
                    ($
                    {Number(item.price || 0).toFixed(2)} each)
                  </div>

                  <div style={{ marginTop: 6 }}>
                    <button
                      onClick={() => removeFromCart(item.id, item.size)}
                      style={{
                        padding: "2px 8px",
                        fontSize: 12,
                        background: "#fbb033",
                        border: "none",
                        borderRadius: 4,
                        cursor: "pointer",
                      }}
                    >
                      Remove Size
                    </button>
                  </div>
                </li>
              ))}
            </ul>

            <div style={{ marginTop: 20, fontWeight: "bold", fontSize: 16 }}>
              Total: ${totalPrice.toFixed(2)}
            </div>

            <div
              style={{
                marginTop: 10,
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={clearCart}
                style={{
                  padding: "4px 12px",
                  background: "#ff4d4f",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                disabled={submitting}
              >
                Clear Cart
              </button>

              <button
                onClick={handleStripeCheckout}
                style={{
                  padding: "4px 12px",
                  background: "#4CAF50",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                disabled={submitting || cartItems.length === 0}
              >
                {submitting ? "Preparing Checkout…" : "Checkout"}
              </button>
            </div>
          </>
        )}
      </div>

      {/* Old modal removed */}
      {/* <CartFormModal ... /> */}
    </>
  );
}

export default CartDrawer;
